export class ReclasificationRequest {
    registerCode: string;
    branchCode: string;
    username: string;
    salesOrg: string;

    paymentList: ReclasificationRequestPayment[];

    constructor() {
        this.registerCode = "";
        this.branchCode = "";
        this.username = "";
        this.salesOrg = "";
        this.paymentList = new Array<ReclasificationRequestPayment>();

    }
}

export class ReclasificationRequestPayment {
    sourceAmount: number = 0;
    sourceCurrency: string = "";
    destinationAmount: number = 0;
    destinationCurrency: string = "";
    sourcePaymentMethod: string = "";
    destinationPaymentMethod: string = "";

    constructor() { }
}